import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: 50,
  },
  pageTitle: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  title: {
    fontFamily: "rokh",
    textAlign: "right",
    fontSize: 20,
    marginTop: 10,
    fontWeight: 900,
  },
  subtitle: {
    textAlign: "right",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
  },
  healthWrapper: {
    gap: 5,
    marginBottom: 10,
    flexDirection: "row-reverse",
  },
  section: {
    width: "35%",
    padding: 15,
    borderRadius: 5,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    border: "1 solid #000",
    backgroundColor: "#cdefff",
  },
  healthTitle: {
    width: "100%",
    fontSize: 14,
    fontWeight: 900,
    marginTop: 5,
    marginRight: 10,
    marginBottom: 5,
    textAlign: "right",
    fontFamily: "rokh",
  },
  healthSubtitle: {
    fontSize: 11.5,
    textAlign: "right",
    width: "100%",
  },
  fullSection: {
    width: "100%",
    marginTop: 20,
  },
  checklistWrapper: {
    gap: 5,
    flexDirection: "row-reverse",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: 2,
  },
  negativeChecklistItem: {
    width: "24.3%",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: 12,
    borderRadius: 5,
    border: "1 solid #ddd",
    backgroundColor: "#ffd6d6",
  },
  positiveChecklistItem: {
    width: "24.3%",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: 12,
    borderRadius: 5,
    border: "1 solid #ddd",
    backgroundColor: "#ecfedb",
  },
  checklistItemTitle: {
    fontFamily: "rokh",
    marginTop: 3,
    fontSize: 9,
    textAlign: "right",
    fontWeight: 900,
  },
  checklistItemSubtitle: {
    fontFamily: "rokh",
    marginTop: 3,
    fontSize: 9,
    textAlign: "right",
    fontWeight: 900,
  },
  notPro: {
    padding: 12,
    backgroundColor: "#FFF1B8",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    width: "75%",
  },
  notProText: {
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "rokh",
    marginTop: 6,
    textAlign: "right",
  },
});

const PdfHealthChecklist = ({ testResults, is_pro }: any) => {
  const checkList = [
    {
      enTitle: "diabetes",
      title: "دیــابت",
      value: "negative",
    },
    {
      enTitle: "anemia",
      title: "کم‌خـــونی",
      value: "negative",
    },
    {
      enTitle: "kidney",
      title: "مشکل در کلــیه‌ها",
      value: "negative",
    },
    {
      enTitle: "fat",
      title: "چربــی خون",
      value: "negative",
    },
    {
      enTitle: "thyroid",
      title: "تیـــروئید",
      value: "negative",
    },
    {
      enTitle: "hepatic",
      title: "مشکل در کبــد",
      value: "negative",
    },
    {
      enTitle: "vitamins",
      title: "ویتامــین‌ها",
      value: "negative",
    },
    {
      enTitle: "inflammation",
      title: "التهــاب و عفونت",
      value: "negative",
    },
    {
      enTitle: "urinary_tract_infection",
      title: "عفونــت مجاری ادراری",
      value: "negative",
    },
    {
      enTitle: "blood_pressure",
      title: "فشــار خون",
      value: "negative",
    },
    {
      enTitle: "gastrointestinal_infections",
      title: "عفــونت‌های گوارشی",
      value: "negative",
    },
    {
      enTitle: "inflammatory_bowel_diseases",
      title: "بیماری‌های التــهابی روده",
      value: "negative",
    },
  ];

  const updatedCheckList = checkList.map((item) => {
    const diseaseInfo =
      testResults?.disease_checklist[item.enTitle.toLowerCase()];
    return diseaseInfo
      ? { ...item, value: "positive", info: diseaseInfo }
      : item;
  });

  return (
    <View style={styles.container}>
      <View style={styles.pageTitle}>
        <Text style={styles.title}>بررسی وضعیت فیزیکی و سلامتی</Text>
        <Text style={styles.subtitle}>
          وضعیت استرس، خواب و فعالیت فیزیکی رو اینجا بررسی کردیم برات
        </Text>
      </View>

      <View style={styles.healthWrapper}>
        <View style={styles.section}>
          <Text style={styles.healthTitle}>وضعیت استرس</Text>
          <Text style={styles.healthSubtitle}>
            {is_pro
              ? testResults?.medical_advice?.stress_state ?? ""
              : "اگه تحلیل پیشرفته رو انتخاب کنی، ما می‌تونیم درباره وضعیت استرست و بهبودش بهت راهکارهای مفیدی بدیم"}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.healthTitle}>وضعیت خواب</Text>
          <Text style={styles.healthSubtitle}>
            {is_pro
              ? testResults?.medical_advice?.sleep_state ?? ""
              : "اگه تحلیل پیشرفته رو انتخاب کنی، ما می‌تونیم درباره وضعیت خوابت و بهبودش بهت راهکارهای مفیدی بدیم"}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.healthTitle}>وضعیت فیزیکی</Text>
          <Text style={styles.healthSubtitle}>
            {is_pro
              ? testResults?.medical_advice?.exirsise_level ?? ""
              : "اگه تحلیل پیشرفته رو انتخاب کنی، ما می‌تونیم درباره وضعیت فعالیت فیزیکی‌ات و بهبودش بهت راهکارهای مفیدی بدیم"}
          </Text>
        </View>
      </View>

      <View style={styles.fullSection}>
        <View style={styles.pageTitle}>
          <Text style={styles.title}>چک‌ لیست سلامت</Text>
          <Text style={styles.subtitle}>
            براتون احتمال تعدادی از بیماری‌های رایج رو بررسی کردیم، دقت کنید که
            این موارد صرفا احتمال هستن و برای تایید حتما باید از پزشک متخصص
            مشورت بگیرید
          </Text>
        </View>

        <View style={styles.checklistWrapper}>
          {updatedCheckList
            .slice(0, is_pro ? Object.entries(updatedCheckList).length : 1)
            .map((item, idx) => (
              <View
                key={item.title}
                style={
                  item.value === "negative"
                    ? styles.negativeChecklistItem
                    : styles.positiveChecklistItem
                }
              >
                <Text style={styles.checklistItemTitle}>{item.title}</Text>
                <Text style={styles.checklistItemSubtitle}>
                  {item.value === "negative" ? "منفی" : "نیاز به بررسی"}
                </Text>
              </View>
            ))}
          {!is_pro && (
            <View style={styles.notPro}>
              <Text style={styles.notProText}>
                برای دیدن بقیه موارد، تحلیل پیشرفته آزمایش رو انتخاب کنید
              </Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default PdfHealthChecklist;
